<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="file-spec-panel" v-html="html" />
</template>

<script setup>
defineProps({
  html: {
    type: String,
    default: "",
  },
});
</script>

<style scoped lang="scss">
.file-spec-panel {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 40vh;

  // sp-alert paints its surface on an inner element that covers the host, so background, radius
  // and padding go through its tokens.
  :deep(sp-alert) {
    display: block;
    margin: 0;
    --sp-comp-alert-background-color: #b3d4fc;
    --sp-comp-alert-text-color: var(--sp-base-font-color, #333);
    --sp-comp-alert-border-radius: var(--sp-ref-border-radius-xs);
    --sp-comp-alert-padding: var(--sp-spacing-4);
    // The content sets its own typography from these, and admin's global rule cannot reach an
    // alert inside this shadow root.
    --sp-comp-alert-content-font-size: var(--sp-sys-typescale-small-font-size, 0.875rem);
    --sp-comp-alert-content-font-weight: var(--sp-ref-font-weight-semi-bold);
    --sp-comp-alert-content-line-height: 1.25;
  }

  :deep(sp-alert) h2 {
    font-size: 1.25rem;
    margin: 0 0 var(--sp-ref-scale-8);
  }

  :deep(sp-alert) h3 {
    margin-top: var(--sp-ref-scale-24);
    margin-bottom: var(--sp-ref-scale-4);
    font-size: 1rem;
  }

  :deep(sp-alert) p {
    margin: 0;
  }

  :deep(sp-alert) p + p {
    margin-top: var(--sp-ref-scale-8);
  }

  :deep(.bulk-import-table-container) {
    max-width: none;
    overflow-x: auto;
    overflow-y: hidden;
  }

  :deep(.bulk-import-table) {
    margin: var(--sp-ref-scale-10) 0;
    border: var(--sp-sys-border-width-default) solid rgba(49, 112, 143, 0.5);
    border-collapse: collapse;
  }

  :deep(.bulk-import-table) th {
    white-space: nowrap;
  }

  :deep(.bulk-import-table) td,
  :deep(.bulk-import-table) th {
    text-align: center;
    padding: var(--sp-ref-scale-4);
    border: var(--sp-sys-border-width-default) solid rgba(49, 112, 143, 0.5);
  }

  :deep(.column-description-container) {
    max-height: var(--sp-ref-scale-96);
    overflow-y: auto;
  }

  :deep(.sample-link) {
    display: none;
  }

  :deep(sp-alert) a {
    color: var(--sp-sys-color-primary, #1976d2);
  }

  :deep(sp-alert) a:hover {
    text-decoration: underline;
  }
}
</style>
